import $ from 'jquery';

export default function (func, options) {
  var settings = {
    interval: 4000,
    pause_onmouseover: true,
    autostart: true
  };

  var helper = {
    start: function (self) {
      var $this = $(self);
      var timer = $this.data('nui-timer') || settings;

      if (timer && timer.callback && !timer.ongoing) {
        timer.timer = setInterval(function () {
          timer.callback.apply(self, arguments);
        }, timer.interval);

        timer.ongoing = true;
        $this.data('nui-timer', timer);
      }
    },
    stop: function (self) {
      var $this = $(self);
      var timer = $this.data('nui-timer') || settings;

      if (!timer.callback) return;

      clearInterval(timer.timer);
      timer.ongoing = false;
      $this.data('nui-timer', timer);
    },
    purge: function (self) {
      var $this = $(self);

      this.stop($this);
      $this.data('nui-timer', null);
      $this.unbind('.nui-timer-event');
    }
  };

  return this.each(function () {
    var $this = $(this);

    if ($.isFunction(func)) {
      if ($.type(options) === 'number') {
        settings.interval = options;
      } else {
        $.extend(settings, options);
      }

      settings.ongoing = false;
      settings.callback = func;

      if (settings.autostart) {
        helper.start(this);
      } else {
        helper.stop(this);
      }

      if (settings.pause_onmouseover) {
        $this.bind({
          'mouseenter.nui-timer-event': function () {
            helper.stop(this);
          },
          'mouseleave.nui-timer-event': function () {
            helper.start(this);
          }
        });
      }
    } else if (helper[func]) {
      helper[func](this);
    }
  });
}
